<div class="page-content">
    <div class="page-header">
        <h1>Accueil</h1>
        <div class="page-description">Bienvenue {{loggedUser.firstname}} {{loggedUser.lastname}} !</div>
    </div>

    <div class="page-body">
        <div class="row">
            <div class="col-sm-12 col-md-3">
                <kpi-card 
                [title]="'Etat des feuilles de temps'"
                [routerLink]="'/main/timesheet/sheet'"
                [isLoading]="isLoadingTimesheets"
                [body]="{value : valueTimesheet}"
                [badge]="{value : badgeValueTimesheet, style: badgeStyleTimesheet}"
                [footer]="{value: footerTimesheet}"
                ></kpi-card>
            </div>
        </div>
        <br/>
        @if(isLoadingBilling || billingData.data.length > 0){
        <div class="row">
             <div class="col-sm-12 col-md-8">
                <table-card 
                    [title]="'Factures des les 30 prochains jours'"
                    [isLoading]="isLoadingBilling"
                    [displayedColumns]="billingColumns"
                    [dataSource]="billingData"
                    (onRowClick)="goToProject($event)"
                    >
                </table-card>
            </div>
        </div>
        }
    </div>
</div>
